import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { getCourseBySlug } from '../services/getCourseBySlug.service'
import { coursesKeys } from '../constants/courses.queryKeys'

export const courseDetailQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: coursesKeys.detail(slug || ''),
    queryFn: () => getCourseBySlug(slug || ''),
    staleTime: 5 * 60 * 1000,
  })

export function useCourse(slug: string) {
  return useSuspenseQuery(courseDetailQueryOptions(slug))
}
